import { render, staticRenderFns } from "./WaveDotsLoader.vue?vue&type=template&id=2f68b49b&scoped=true&"
import script from "./WaveDotsLoader.vue?vue&type=script&lang=js&"
export * from "./WaveDotsLoader.vue?vue&type=script&lang=js&"
import style0 from "./WaveDotsLoader.vue?vue&type=style&index=0&id=2f68b49b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68b49b",
  null
  
)

export default component.exports